@if (product$|async; as product) {
  <div [appStoryblok]="_editable()" class="product">
    <div class="product-image">
      <img [ngSrc]="product?.image?.original ?? ''" alt="" fill/>
    </div>
    <div class="">
      <p class="product-title">
        <span class="pe-2">{{ product.name }}</span>
        <span class="alcohol">
          {{ product.meta?.alcohol }} % ALK.
        </span>
      </p>
      @for (rating of ratings(product); track rating.id) {
        <div>
          <app-product-rating-points [rating]="rating" class="rating-points"></app-product-rating-points>
          <span class="rating-dot">•</span>
          <span class="rating-label">{{ rating.name }}</span>
        </div>
      }
    </div>
    @if (product.meta?.foods?.length) {
      <div class="product-foods-container">
        <p class="product-foods-title">God til f.eks.:</p>
        @if (productStoryblok$|async; as productStoryblok) {
          <div class="product-foods">
            @for (food of getFoods(product); track food.label) {
              <div class="product-food">
                <img [ngSrc]="productService.getItemIcon(food?.iconName ?? '', productStoryblok)" height="52"
                     width="52"/>
                <p class="mb-0 mt-1">{{ food?.label }}</p>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}
